import { Injectable, inject } from '@angular/core';
import {
  RainViewerApiService,
  RainViewerRadar,
  RainViewerSatellite,
  RainViewerWeatherResponse,
} from '@cropx-common/services/api-gateway/RainViewerApiService';
import {
  Action,
  State,
  StateContext,
  createPropertySelectors,
} from '@ngxs/store';
import dayjs from 'dayjs';
import { Observable } from 'rxjs';
import { finalize, tap } from 'rxjs/operators';

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace RainViewer {
  const type = 'rainviewer';

  export class GetWeatherMaps {
    static readonly type = `[${type}] GetWeatherMaps`;

    constructor() {}
  }
}

export interface RainViewerStateModel {
  weatherMapsLoading: boolean;
  generatedTime: number;
  hostUrl: string;
  radar: RainViewerRadar;
  satellite: RainViewerSatellite;
}

@State<RainViewerStateModel>({
  name: 'rainviewers',
  defaults: {
    weatherMapsLoading: false,
    generatedTime: 0,
    hostUrl: '',
    radar: null,
    satellite: null,
  },
})
@Injectable()
export class RainViewerState {
  private rainViewerApi = inject(RainViewerApiService);

  @Action(RainViewer.GetWeatherMaps)
  getWeatherMaps(ctx: StateContext<RainViewerStateModel>): Observable<any> {
    const minuteDiff = dayjs(dayjs()).diff(
      ctx.getState().generatedTime,
      'minute',
    );

    if (minuteDiff <= 10) {
      return;
    }

    ctx.patchState({ weatherMapsLoading: true });
    return this.rainViewerApi.getWeather().pipe(
      tap((response: RainViewerWeatherResponse) => {
        ctx.patchState({
          generatedTime: response.generated * 1000,
          radar: response.radar,
          hostUrl: response.host,
          satellite: response.satellite,
        });
      }),
      finalize(() => {
        ctx.patchState({ weatherMapsLoading: false });
      }),
    );
  }
}

export class RainViewerStateSelectors {
  static slices =
    createPropertySelectors<RainViewerStateModel>(RainViewerState);
}
